export default __webpack_public_path__ + "static/media/O-002.3abe825d.png";